import request from "../../util/request";

export function landingPageOperationList(model) {
    return request({
        url: '/api-admin/landing_page/operation/config/list',
        method: 'post',
        data: model
    })
}

/**
 * 启用落地页操作
 *
 * @param params
 * @returns {*}
 */
export function enableLandingPageOperation(params) {
    return request({
        url: '/api-admin/landing_page/operation/config/enable/' + params.code,
        method: 'put',
        query: {}
    })
}

/**
 * 禁用落地页操作
 *
 * @param params
 * @returns {*}
 */
export function disableLandingPageOperation(params) {
    return request({
        url: '/api-admin/landing_page/operation/config/disable/' + params.code,
        method: 'put',
        query: {}
    })
}

export function editLandingPageOperation(model) {
    return request({
        url: '/api-admin/landing_page/operation/config',
        method: 'put',
        data: model
    })
}

export function landingPageOperationDownList(params) {
    return request({
        url: '/api-admin/landing_page/operation/config/operation/down_list',
        method: 'get',
        params: params
    })
}